export const ELASTIC_SEARCH_MAX_ITEMS = 10_000;
